import { render } from "./a-order.vue?vue&type=template&id=74ef00ce&scoped=true"
import script from "./a-order.vue?vue&type=script&lang=js"
export * from "./a-order.vue?vue&type=script&lang=js"

import "./a-order.vue?vue&type=style&index=0&id=74ef00ce&lang=scss&scoped=true"

import exportComponent from "/www/publicHouse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74ef00ce"]])

export default __exports__